module.exports = __webpack_public_path__ + "media/images/alerta_parada-f936276151229e209bbe8c38ce460273.jpg";